<div class="container-fluid">
  <div class="row justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
        {{ 'bikeshop.menu.pos_products' | translate }}

      </span>
    </div>
  </div>
  <div class="content pos-products-page" style="margin-bottom: 128px;"
    [ngClass]="{'can-edit-product': canManageProducts }">
    <div>
      <div class="pos-products-actions">
        <div *ngIf="canManageProducts">
          <hub-button [style]="'outline'" [icon]="'upload'" [size]="'xl'"
            pTooltip="{{ 'bikeshop.pos_products.import-products' | translate }}" tooltipPosition="bottom"
            (buttonClick)="importProducts()"></hub-button>
        </div>
        <div *ngIf="canManageProducts">
          <hub-button [style]="'outline'" [icon]="'grid-plus'" [size]="'xl'"
            pTooltip="{{ 'bikeshop.pos_products.add_product' | translate }}" tooltipPosition="bottom"
            (buttonClick)="addProduct()"></hub-button>
        </div>
        <div>
          <hub-button [style]="'outline'" [icon]="'refresh'" [size]="'xl'" [disabled]="loading" [loading]="loading"
            pTooltip="{{ 'bikeshop.pos_products.refresh_note' | translate }}" tooltipPosition="bottom"
            (buttonClick)="refreshPOSProducts()"></hub-button>
        </div>
      </div>

      <!-- Search -->
      <div class="pos-products-search">
        <hub-input [(ngModel)]="searchTerm" [allowClear]="true" [icon]="'search'" [iconColor]="'#888888'"
          (keydown.enter)="search()" (ngModelChange)="onSearchTermChange($event)"
          placeholder="{{ 'general.search' | translate }}"></hub-input>
      </div>

      <!-- Collection pills -->
      <div class="collection-header-container">
        <div class="collection-items">
          <div *ngFor="let collection of collections" [ngClass]="{'selected': collection.selected}"
            (click)="collectionSelected(collection)">
            <div>{{ collection.collectionName }}</div>
            <div *ngIf="collection.id !== 'ALL'" class="collection-badge">{{ collection.count }}</div>
          </div>
        </div>
        <div class="collection-button-container">
          <hub-button [style]="'outline'" [icon]="'plus-alt'" [size]="'xl'"
            pTooltip="{{ 'bikeshop.workshop.jobcard.quote.create_a_collection' | translate }}" tooltipPosition="bottom"
            (buttonClick)="createCollection()"></hub-button>
          <hub-button [style]="'outline'" [icon]="'gear'" [size]="'xl'"
            pTooltip="{{ 'bikeshop.workshop.jobcard.quote.manage_collections' | translate }}" tooltipPosition="bottom"
            (buttonClick)="manageCollections()"></hub-button>
        </div>
      </div>
      <!-- Results -->
      <div *ngIf="products.length > 0 && !searching" style="margin-top:18px;">
        <p-table #productsTable [columns]="columns" [value]="products" [scrollable]="true" scrollHeight="calc(100vh - 380px)"
        [paginator]="true" [rows]="pageSize" [(first)]="first" (onPage)="onPageChange($event)">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <!-- <th *ngIf="canManageProducts" style="width:44px"> -->
              <th style="width:44px">
                <div style="width: 22px;display: flex; justify-content: center;align-items: flex-start;">
                  <p-checkbox pTooltip="{{'bikeshop.pos_products.select_all_tooltip' | translate}}" [binary]="true"
                    [(ngModel)]="globalSelectValue" [disabled]="busyBulkActioning"
                    (onChange)="globalSelected($event)"></p-checkbox>
                </div>
              </th>
              <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''"
                [ngStyle]="{ 'width': col.width }">
                {{ col.header }}
                <p-sortIcon [field]="col.field" style="vertical-align: middle;" *ngIf="col.type !== 'action'">
                </p-sortIcon>
              </th>

            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product let-columns="columns">
            <tr [pSelectableRow]="product" (click)="editProduct(product)">
              <!-- <td (click)="$event.stopPropagation()" *ngIf="canManageProducts" style="width:44px"> -->
              <td (click)="$event.stopPropagation()" style="width:44px">
                <div class="bulk-action-button">
                  <p-checkbox [(ngModel)]="product.selected" (onChange)="selectProductCheck($event)"
                    [disabled]="busyBulkActioning" [binary]="true"></p-checkbox>
                </div>
              </td>
              <td *ngFor="let col of columns" (click)="col.type === 'checkbox' && $event.stopPropagation()">
                <p-checkbox *ngIf="col.type === 'checkbox'" [(ngModel)]="product[col.field]" [binary]="true"
                  (onChange)="markProductForLabour(product, col)"></p-checkbox>
                <div *ngIf="col.type !== 'action' && col.type !== 'checkbox'">
                  {{
                  col.type === 'currency'
                  ? (product[col.field] | currency: currencySymbol)
                  : col.type === 'currencyVAT'
                  ? (product[col.field] * (1 + VATRate)
                  | currencyVAT: currencySymbol)
                  : col.type === 'boolean'
                  ? product[col.field]
                  ? 'Yes'
                  : 'No'
                  : product[col.field]
                  }}
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <!-- Loading -->
      <div *ngIf="searching" style="display: flex; justify-content: center; margin-top: 32px;">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s"></p-progressSpinner>
      </div>
      <div class="empty-state-container" *ngIf="!searched && !searching">
        <img src="../../../../../assets/images/no_customers.png" alt="Empty State" class="empty-state-image">
        <div class="empty-state-header-text">{{ 'bikeshop.pos_products.start_searching' | translate }}</div>
        <div class="empty-state-header-text">{{ 'bikeshop.pos_products.start_searching_details' | translate }}</div>
      </div>

      <!-- No products found (1.8) -->
      <div class="empty-state-content" *ngIf="searched && searchedTerm && !searching && products.length === 0">
        <div>
          <span class="fa fa-search fa-3x"></span>
        </div>
        <div>
          <div class="empty-state-text">
            <div class="empty-state-header-text">{{ 'bikeshop.pos_products.no_products_found' | translate }} {{
              searchedTerm }}</div>
            <div class="empty-state-header-text">{{ 'bikeshop.cyclist.search_something_else' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>






<div class="bulk-action-container active pos-products-bulk-actions">
  <div *ngIf="busyBulkActioning" style="margin-top: 16px;display: flex;justify-content: center;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
    </p-progressSpinner>
  </div>
  <ng-container *ngIf="!busyBulkActioning">
    <div>
      <button class="iso-round-button iso-secondary" (click)="addToCollection()" [disabled]="!isProductsSelected()">{{
        'bikeshop.pos_products.add_to_collection' | translate }}</button>
    </div>
    <div *ngIf="selectedCollection?.id !== 'ALL'">
      <button class="iso-round-button iso-secondary" (click)="removeFromCollection()"
        [disabled]="!isProductsSelected()">{{
        'bikeshop.pos_products.remove_from_collection' | translate }}</button>
    </div>
    <div *ngIf="canManageProducts">
      <button class="iso-round-button iso-light error-button" (click)="bulkDelete()"
        [disabled]="!isProductsSelected()">{{ 'bikeshop.pos_products.bulk_delete_selected' | translate }}</button>
    </div>
  </ng-container>
</div>

<!-- OLD CODE BEFORE TREK 1.18 -->
<ng-container *ngIf="false">
  <div>
    <p-table #productsTable [columns]="columns" [value]="products" [paginator]="true" [rows]="25"
      *ngIf="gearTypes.length > 0">
      <ng-template pTemplate="caption">
        <div class="margin-top-8 filter-bar">
          <div class="refresh-products">
            <span pTooltip="{{ 'bikeshop.pos_products.refresh_note' | translate }}" [ngClass]="{ 'fa-spin': loading }"
              (click)="refreshPOSProducts()" tooltipPosition="left" class="fa hubtiger-sync"></span>
          </div>
          <div class="add-new" *ngIf="canManageProducts">
            <div pTooltip="{{ 'bikeshop.pos_products.add_product' | translate }}" tooltipPosition="left"
              class="hubtiger-add pull-right" (click)="addProduct()"></div>
          </div>
          <div class="add-new" *ngIf="canManageProducts">
            <div pTooltip="{{ 'bikeshop.pos_products.import-products' | translate }}" tooltipPosition="left"
              class="fa fa-cloud-upload pull-right" (click)="importProducts()"></div>
          </div>


          <div class="p-inputgroup col-12 mb-2">
            <div style="width: 100%; float: left;">
              <daz-icon class=" icon-shift-12 iso-search-icon-service" [name]="'search'" [size]="'22px'"
                [color]="'#888888'"></daz-icon>
              <input type="text" class="iso-search-bar-service"
                (input)="productsTable.filterGlobal($event.target['value'] , 'contains')"
                placeholder="{{ 'general.search' | translate }}" />
            </div>
            <!--              <input type="text" pInputText size="10"-->
            <!--                     (input)="productsTable.filterGlobal($event.target['value'] , 'contains')"-->
            <!--                     placeholder="{{ 'general.search' | translate }}"/>-->
            <!--              <span class="p-inputgroup-addon mr-3"><i class="fa hubtiger-search"></i></span>-->
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngIf="canManageProducts && products && products.length > 0" style="width:44px">
            <div style="width: 22px;display: flex; justify-content: center;align-items: flex-start;">
              <p-checkbox pTooltip="{{'bikeshop.pos_products.select_all_tooltip' | translate}}" [binary]="true"
                [(ngModel)]="globalSelectValue" [disabled]="busyBulkActioning"
                (onChange)="globalSelected($event)"></p-checkbox>
            </div>
          </th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''">
            {{ col.header }}
            <p-sortIcon [field]="col.field" style="vertical-align: middle;" *ngIf="col.type !== 'action'">
            </p-sortIcon>
          </th>
          <!--<th>{{ 'general.select_multiple_replacement' | translate }}</th>
            <th style="width: 60px;"></th>-->
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product let-columns="columns">
        <tr [pSelectableRow]="product" (click)="editProduct(product)">
          <td (click)="$event.stopPropagation()" *ngIf="canManageProducts" style="width:44px">
            <div class="bulk-action-button">
              <p-checkbox [(ngModel)]="product.selected" (onChange)="selectProductCheck($event)"
                [disabled]="busyBulkActioning" [binary]="true"></p-checkbox>
            </div>
          </td>
          <td *ngFor="let col of columns">
            <div *ngIf="col.type !== 'action'">
              {{
              col.type === 'currency'
              ? (product[col.field] | currency: currencySymbol)
              : col.type === 'currencyVAT'
              ? (product[col.field] * (1 + VATRate)
              | currencyVAT: currencySymbol)
              : col.type === 'boolean'
              ? product[col.field]
              ? 'Yes'
              : 'No'
              : product[col.field]
              }}
            </div>
          </td>
          <!--<td style="text-align:center;">
              <p-checkbox
                [(ngModel)]="product['multipleReplacements']"
                [binary]="true"
                (click)="setReplacement(product)"
              ></p-checkbox>
            </td>-->
          <!--<td style="text-align:left;position: relative;overflow:visible;">
              <div
                pTooltip="{{ 'bikeshop.pos_products.edit' | translate }}"
                tooltipPosition="left"
                class="fa fa-wrench font-button"
                (click)="componentUpdate.toggle($event)"
              ></div>
              <div class="badge" *ngIf="product['LinkedGear'].length > 0">
                {{ product['LinkedGear'].length }}
              </div>
              <div style="position: absolute;right: 742px;">
                <p-overlayPanel
                  #componentUpdate
                  [dismissable]="false"
                  [showCloseIcon]="true"
                >
                  <app-service-replacement-setup
                    [lineItem]="product"
                    [products]="products"
                    [gearTypes]="gearTypes"
                    [component]="componentUpdate"
                  ></app-service-replacement-setup>
                </p-overlayPanel>
              </div>
            </td>-->
        </tr>
      </ng-template>
    </p-table>
  </div>
</ng-container>

<p-sidebar #NavSideBar [(visible)]="showProductDetail" position="right"
  [style]="{width:'62em', background: '#F6F6F8', 'overflow-x': 'auto'}" (onHide)="NavSideBar.destroyModal()">
  <div *ngIf="showProductDetail">
    <app-product-add-edit [product]="selectedProduct" (close)="closeProductDetail()"
      (update)="productUpdated($event)"></app-product-add-edit>
  </div>
</p-sidebar>


<!-- <div class="bulk-action-container" [ngClass]="{'active': isProductsSelected()}">
  <div *ngIf="busyBulkActioning" style="margin-top: 16px;display: flex;justify-content: center;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
    </p-progressSpinner>
  </div>
  <div *ngIf="!busyBulkActioning">
    <button class="iso-round-button iso-light error-button" (click)="bulkDelete()" [disabled]="busyBulkActioning">{{
      (globalSelectValue ? 'bikeshop.pos_products.bulk_delete_all' : 'bikeshop.pos_products.bulk_delete_selected') | translate
    }}</button>
  </div>
</div> -->

<p-confirmDialog></p-confirmDialog>
<p-toast position="bottom-center" key="bottom-center" styleClass="hubtiger-toast"></p-toast>